import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=1a833759&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=1a833759&scoped=true&lang=css"
import style1 from "./ContactUs.vue?vue&type=style&index=1&id=1a833759&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a833759",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/chaoangoods.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a833759')) {
      api.createRecord('1a833759', component.options)
    } else {
      api.reload('1a833759', component.options)
    }
    module.hot.accept("./ContactUs.vue?vue&type=template&id=1a833759&scoped=true", function () {
      api.rerender('1a833759', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contactus/ContactUs.vue"
export default component.exports